<template>
<ListView
    ref="list"
    title="Knowledge Base"
    :show-id="false"
    :api-paging="false"
    :api-search="false"
    :api-delete="require('@/common/api').default.knowledgeDelete"
    :create-item-component="KnowledgeModalComponent"
    :api-list="require('@/common/api').default.knowledge"
    :columns="[
        { title: 'Name', name: 'name', width: 150 },
        { title: 'Text', name: 'text', type: 'custom' },
    ]"
    :menu-items="menuItems">
    <template v-slot:custom="props">
        <div v-if="props.column.name === 'text'">
            <code v-if="props.item.text" class="m-0 text-break break-words text-wrap" >{{props.item.text.substring(0, 200)}} {{props.item.text.length > 200 ? '&#x2026;' : ''}}</code>
        </div>
    </template>
    <template v-slot:default>
        <KnowledgeModal ref="edit"></KnowledgeModal>
    </template>
    <template v-slot:create>
        <button class="btn btn-outline-primary">
            Import API key
        </button>
    </template>
</ListView>

</template>

<script>
import ListView from "@/views/templates/ListView.vue";
import api from "@/common/api";
import KnowledgeModal from "@/components/local/KnowledgeModal.vue";

export default {
    computed: {
        KnowledgeModalComponent() {
            return KnowledgeModal;
        }
    },
    components: {
        ListView, KnowledgeModal
    },
    data() {
        return {
            loaded: false,
            selectedItem: null,

            menuItems: [
                { title: "Edit", callback: this.updateStart }
            ]
        };
    },
    methods: {
        updateStart(item) {
            this.selectedItem = item;
            this.$refs.edit.openEdit(item, (_, close) => {
                close();
                this.load();
            });
        },
        updateItem(item) {
            this.loaded = false;
            api.knowledgeUpdate(item).then(data => {
                this.loaded = true;
                this.$refs.list.load();
                this.$refs["file-upload"].value = "";
            }).catch(e => {
                this.flashError(e);
                this.loaded = true;
            });
        },
        load() {
            this.$refs.list.load();
        }
    }
};
</script>
